<template>
  <v-container>
    <div v-if="!loading">
      <v-row no-gutters class="mb-6">
        <v-col cols="1">
          <router-link to="/overview" class="back-arrow"
            ><v-icon large class="mr-4">{{
              icons.mdiArrowLeft
            }}</v-icon></router-link
          >
        </v-col>
        <v-col cols="12" sm="11">
          <h1>Choose your payment plan</h1>
        </v-col>
      </v-row>
      <v-row
        v-if="firstWillFree || insuranceEnabled"
        class="text-center no-gutters"
      >
        <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3">
          <h2 v-if="firstWillFree">Your first will is FREE</h2>
          <ul v-if="firstWillFree && insuranceEnabled">
            <li class="mb-2">
              Select below which plan you prefer for future updates to your will
              and additional benefits if you choose the subscription package.
            </li>
            <li class="mb-2">
              If you take out the {{ whitelabel.insurancePolicyName }} insurance
              policy, you will also get all the subscription package benefits
              with your policy for free.
            </li>
          </ul>
          <p v-else-if="firstWillFree">
            Select below which plan you prefer for future updates to your will
            and additional benefits if you choose the subscription package
          </p>
          <p v-else-if="insuranceEnabled">
            If you take out the {{ whitelabel.insurancePolicyName }} insurance
            policy, you will also get all the subscription package benefits with
            your policy for free
          </p>
          <v-btn
            v-if="insuranceEnabled"
            rounded
            depressed
            large
            color="primary"
            to="/insurance/explanation"
          >
            Get {{ whitelabel.insurancePolicyName }} Policy Now
          </v-btn>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-6">
        <v-col md="12" cols="12">
          <PaymentPlanBlock
            title="ONCE OFF PACKAGE"
            :sub-title="'R' + onceOffPrice"
            :benefits="{
              'Will storage': ['You store original will'],
              'Will updates': ['Unlimited updates', 'Unlimited downloads'],
              'Helping your Executor': [
                'Fixed list of assets included with will',
                'You ensure your Executor knows where to find original will',
                'Unlimited will validations',
              ],
            }"
            link-path="/basic-payment"
          />
        </v-col>
      </v-row>
    </div>
    <div v-else class="text-center">
      <v-progress-circular indeterminate color="primary" />
    </div>
  </v-container>
</template>

<script>
  import PaymentPlanBlock from './PaymentPlanBlock.vue';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';

  export default {
    name: 'PaymentPlanPage',
    components: {
      PaymentPlanBlock,
    },
    data() {
      return {
        loading: true,
        testator: {},
      };
    },
    computed: {
      onceOffPrice() {
        return process.env.VUE_APP_ONCE_OFF_PRICE;
      },
      subscriptionPrice() {
        return process.env.VUE_APP_SUBSCRIPTION_PRICE;
      },
      insuranceEnabled() {
        return this.testator.enabledFeatures.includes('full_insurance');
      },
      firstWillFree() {
        return this.testator.isEntitledToFirstWillFree;
      },
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        result(response) {
          if (response.data && response.data.testator) {
            if (this.testator.hasActivePayment) {
              this.$router.push('/overview');
            }
            this.loading = false;
          }
        },
      },
    },
  };
</script>
